export function missingSession(session, now = new Date().toISOString()) {
  if (!session) return session;
  return { ...session, status: "missing", transport: null, turns: (session.turns || []).map((turn) =>
    ["running", "unknown"].includes(turn.status) ? { ...turn, status: "failed", finishedAt: now,
      recovery: null, error: "This session could not be found.",
      setup: turn.setup ? { ...turn.setup, status: "failed" } : null } : turn) };
}
export function recoveryLabel(recovery, provider = "Agent") {
  if (!recovery) return null;
  const progress = recovery.attempt ? ` — ${recovery.attempt}/${recovery.maxAttempts}` : "";
  if (recovery.state === "stop_failed") return recovery.message || "Stop could not be confirmed. Reconnect and try again.";
  if (recovery.state === "stopping") return "Stopping — waiting for the container to confirm. Connection retries remain active.";
  if (recovery.state === "offline") return recovery.message || "Container unreachable. The job may still be running. Reconnect to check.";
  if (recovery.layer === "container") return `Container connection lost. Reconnecting${progress}. The job may still be running.`;
  if (recovery.layer === "cli") return `Checking ${provider} availability again${progress}.`;
  if (recovery.layer === "account") {
    const from = recovery.fromLabel || recovery.from || "the current account";
    const to = recovery.toLabel || recovery.to || "another account";
    return `Usage limit reached — switched from ${from} to ${to}. Continuing the conversation.`;
  }
  return `${provider} was interrupted. Continuing the existing conversation${progress}.`;
}
